package tta.destinigo.talktoastro.core.navigation_decompose.web_history_controller


import tta.destinigo.talktoastro.core.navigation_decompose.configruation.Configuration
import tta.destinigo.talktoastro.core.navigation_decompose.web_history_controller.NavigationStackFactory.Paths.COURSE_LESSON
import tta.destinigo.talktoastro.core.navigation_decompose.web_history_controller.NavigationStackFactory.Paths.COURSE_VEDIO
import tta.destinigo.talktoastro.core.navigation_decompose.web_history_controller.NavigationStackFactory.Paths.NOTIFICATION_LIST

object NavigationStackFactory {

    fun getInitialStack(
        webHistoryPaths: List<String>? = null,
        deepLink: DeepLink = DeepLink.None
    ): List<Configuration> {
        val historyConfigs = webHistoryPaths
            ?.filterNot { it.isEmpty() }
            ?.map { getConfigForPath(it) }
            ?.distinct()
            ?: emptyList()

        return historyConfigs.ifEmpty { getInitialStack(deepLink) }
    }

    private fun getInitialStack(deepLink: DeepLink): List<Configuration> {

        return when (deepLink) {
            is DeepLink.None -> listOf(Configuration.BottomNavigationConfiguration)
            is DeepLink.Web -> listOfNotNull(
                Configuration.BottomNavigationConfiguration,
                getConfigForPath(deepLink.path)
            ).distinct()
        }
    }

    // Path constants
    private object Paths {
        const val LOGIN_PAGE = "login"
        const val OTP_VALIDATION_PAGE = "validate-otp"
        const val REGISTRATION_PAGE = "registration"
        const val EXPERT_LIST_PAGE = "fetch-consultants"
        const val EXPERT_DETAILS_PAGE = "expert-details"
        const val CHOOSE_RECHARGE_PAGE = "choose-recharge"
        const val RECHARGE_CHECKOUT_PAGE = "recharge-checkout"
        const val MORE_SCREEN_TAB = "more"
        const val HOME_SCREEN_TAB = ""
        const val PRIVACY_POLICY_PAGE = "privacy-policy"
        const val TERMS_AND_CONDITIONS_PAGE = "terms-and-conditions"
        const val EDIT_PROFILE_SCREEN = "edit-profile"
        const val PAYMENT_GATEWAY_PAGE = "payment-gateway"
        const val RECHARGE_FAILURE_PAGE = "recharge-failure"
        const val RECHARGE_SUCCESS_PAGE = "recharge-success"
        const val CHAT_CONSULTATION_INFO_PAGE = "chat-consultation-info"
        const val DISPLAY_SEARCH_EXPERT_LIST_PAGE = "display-search-expert-list"
        const val CHAT_CONCERN_PAGE = "chat-concern"
        const val CALL_CONSULTATION_INFO_PAGE = "call-consultation-info"
        const val CALL_CONSULTATION_OPTION = "call-consultation-options"
        const val CALL_PLACE_SUCCESS = "call-place-success"
        const val CALL_WAITING_SUCCESS_COMPONENT = "call-waiting-success"
        const val TRANSACTION_HISTORY = "transaction-history"
        const val VOIP_CALL_CONSULTATION = "voip_call_consultation"
        const val CHAT_HISTORY = "chat-history"
        const val CHAT_CONVERSATION_SCREEN = "chat-conversation-screen"
        const val ARTICLE = "article"
        const val CUSTOM_ORDER = "custom-order"
        const val CUSTOM_ORDER_DETAILS = "custom-order-details"
        const val CUSTOM_ORDER_LESSON = "custom-order-lesson"
        const val COURSES = "course"
        const val PURCHASE_HISTORY = "purchase-history"
        const val REFER_AND_EARN = "refer-and-earn"
        const val POST = "post"
        const val POST_DETAILS = "post-details"
        const val FAVORITE_TAB = "favorite"
        const val ABOUT_US = "about-us"
        const val CONTACT_US = "contact-us"
        const val COURSE_VEDIO = "course-preview-video"
        const val COURSE_LESSON = "course-lesson"
        const val NOTIFICATION_LIST = "missed-notification"

    }

    fun getPathForConfig(config: Configuration): String {
        return when (config) {
            is Configuration.LoginPage -> "/${Paths.LOGIN_PAGE}"
            is Configuration.OtpValidationPage -> "/${Paths.OTP_VALIDATION_PAGE}"
            is Configuration.RegistrationPage -> "/${Paths.REGISTRATION_PAGE}"
            is Configuration.ExpertListPage -> "/${Paths.EXPERT_LIST_PAGE}?category=${config.categoryName}&cat_source=${config.categoryId}"
            is Configuration.ExpertDetailsPage -> "/${Paths.EXPERT_DETAILS_PAGE}?expert=${config.expertId}"
            is Configuration.ChoseRechargePage -> "/${Paths.CHOOSE_RECHARGE_PAGE}"
            is Configuration.RechargeCheckout -> "/${Paths.RECHARGE_CHECKOUT_PAGE}?amount=${config.rechargeData?.amount}&amount_source=${config.rechargeData?.id}&plan=${config.rechargeData?.planName}"
            is Configuration.RechargeFailure -> "/${Paths.RECHARGE_FAILURE_PAGE}?amount=${config.topUpAmount}"
            is Configuration.RechargeSuccess -> "/${Paths.RECHARGE_SUCCESS_PAGE}?amount=${config.topUpAmount}"
            is Configuration.MoreScreenTab -> "/${Paths.MORE_SCREEN_TAB}"
//            is Configuration.HomeScreenTab -> Paths.HOME_SCREEN_TAB
            is Configuration.PrivacyPolicyPage -> "/${Paths.PRIVACY_POLICY_PAGE}"
            is Configuration.TermsAndConditions -> "/${Paths.TERMS_AND_CONDITIONS_PAGE}"
            is Configuration.EditProfileScreen -> "/${Paths.EDIT_PROFILE_SCREEN}"
            is Configuration.PaymentGateway -> "/${Paths.PAYMENT_GATEWAY_PAGE}"
            is Configuration.DisplaySearchExpertList -> "/${Paths.DISPLAY_SEARCH_EXPERT_LIST_PAGE}"
            is Configuration.ChatConcernPage -> "/${Paths.CHAT_CONCERN_PAGE}?expert=${config.expertId}"
            is Configuration.CallPlaceSuccessful -> "/${Paths.CALL_PLACE_SUCCESS}?expert_source=${config.expertId}&expert=${config.expertName}&image=${config.expertImage}&skills=${config.expertSkills}"
            is Configuration.CallWaitingSuccessComponent -> "/${Paths.CALL_WAITING_SUCCESS_COMPONENT}?expert_source=${config.expertId}&expert=${config.expertName}&image=${config.expertImage}&skills=${config.expertSkills}"
            is Configuration.TransactionHistoryComponent -> "/${Paths.TRANSACTION_HISTORY}"
            is Configuration.VoIPCallConfig -> "/${Paths.VOIP_CALL_CONSULTATION}"
            is Configuration.ChatHistory -> "/${Paths.CHAT_HISTORY}"
            is Configuration.ChatConversationScreen -> "/${Paths.CHAT_CONVERSATION_SCREEN}"
            is Configuration.CustomOrderPage -> "/${Paths.CUSTOM_ORDER}"
            is Configuration.PurchaseHistoryConfig -> "/${Paths.PURCHASE_HISTORY}"
            is Configuration.ReferAndEarnConfig -> "/${Paths.REFER_AND_EARN}"
            is Configuration.PostScreenConfig -> "/${Paths.POST}"
            is Configuration.PostDetailsConfig -> "/${Paths.POST_DETAILS}/${config.id}"
            is Configuration.ArticleDetailPageConfig -> "/${Paths.ARTICLE}/${config.slug}"
            is Configuration.CustomOrderDetails -> "/${Paths.CUSTOM_ORDER_DETAILS}"
            is Configuration.FavoriteScreenConfig -> "/${Paths.FAVORITE_TAB}"
            is Configuration.CoursesPageConfig -> "/${Paths.COURSES}"
            is Configuration.CoursePageConfig -> "/${Paths.COURSES}/${config.slug}"
            is Configuration.AboutUsConfig -> "/${Paths.ABOUT_US}"
            is Configuration.ContactUsConfig -> "/${Paths.CONTACT_US}"
            is Configuration.BottomNavigationConfiguration -> Paths.HOME_SCREEN_TAB
            Configuration.ArticleListPageConfig -> "/${Paths.ARTICLE}"
            is Configuration.CourseVedio -> "/$COURSE_VEDIO/${config.data}"
            is Configuration.CourseLessonConfig -> "/$COURSE_LESSON"
            is Configuration.NotificationConfig -> "/$NOTIFICATION_LIST"
        }
    }

    private fun parseQueryParameters(query: String?): Map<String, String>? {
        return query?.split("&")
            ?.mapNotNull { param ->
                val keyValuePair = param.split("=", limit = 2)
                if (keyValuePair.size == 2 && keyValuePair[0].isNotEmpty()) {
                    keyValuePair[0].trim() to keyValuePair[1].trim()
                } else null
            }
            ?.toMap()
    }

    fun getConfigForPath(path: String): Configuration {
        val pathWithoutPrefix = path.removePrefix("/")
        val parts = pathWithoutPrefix.split("?", limit = 2)
        val route = parts[0]
        val query = parts.getOrNull(1)
        val pathSegments = pathWithoutPrefix.split("/")
        val queryParams = parseQueryParameters(query)

        if (pathSegments.firstOrNull() == Paths.COURSES) {
            val slug = pathSegments.getOrNull(1)
            return if (slug.isNullOrBlank()) Configuration.CoursesPageConfig
            else Configuration.CoursePageConfig(slug)
        }

        return when {
            pathSegments.firstOrNull() == Paths.ARTICLE -> Configuration.ArticleListPageConfig
            route == Paths.LOGIN_PAGE -> Configuration.LoginPage
            route == Paths.OTP_VALIDATION_PAGE -> Configuration.LoginPage
            route == Paths.REGISTRATION_PAGE -> Configuration.RegistrationPage
            route == Paths.EXPERT_LIST_PAGE -> Configuration.ExpertListPage(
                categoryName = queryParams?.get("category") ?: "",
                categoryId = queryParams?.get("cat_source") ?: "",
                subCategory = null
            )
            route in listOf(
                Paths.EXPERT_DETAILS_PAGE,
                Paths.CHAT_CONSULTATION_INFO_PAGE,
                Paths.CHAT_CONCERN_PAGE,
                Paths.CALL_CONSULTATION_INFO_PAGE,
                Paths.CALL_CONSULTATION_OPTION
            ) -> Configuration.ExpertDetailsPage(
                expertId = queryParams?.get("expert")?.toIntOrNull() ?: 0
            )
            route == Paths.CHOOSE_RECHARGE_PAGE -> Configuration.ChoseRechargePage
            route == Paths.RECHARGE_FAILURE_PAGE -> Configuration.RechargeFailure(
                topUpAmount = queryParams?.get("amount") ?: ""
            )
            route == Paths.RECHARGE_SUCCESS_PAGE -> Configuration.RechargeSuccess(
                topUpAmount = queryParams?.get("amount") ?: ""
            )
            route == Paths.MORE_SCREEN_TAB -> Configuration.MoreScreenTab
            route == Paths.PRIVACY_POLICY_PAGE -> Configuration.PrivacyPolicyPage
            route == Paths.TERMS_AND_CONDITIONS_PAGE -> Configuration.TermsAndConditions
            route == Paths.EDIT_PROFILE_SCREEN -> Configuration.EditProfileScreen
            route == Paths.PAYMENT_GATEWAY_PAGE -> Configuration.ChoseRechargePage
            route == Paths.DISPLAY_SEARCH_EXPERT_LIST_PAGE -> Configuration.DisplaySearchExpertList
            route == Paths.CALL_PLACE_SUCCESS -> Configuration.CallPlaceSuccessful(
                expertId = queryParams?.get("expert_source") ?: "",
                expertName = queryParams?.get("expert") ?: "",
                expertImage = queryParams?.get("image") ?: "",
                expertSkills = queryParams?.get("skills") ?: "",
                callType = queryParams?.get("callType") ?: ""
            )
            route == Paths.CALL_WAITING_SUCCESS_COMPONENT -> Configuration.CallWaitingSuccessComponent(
                expertId = queryParams?.get("expert_source") ?: "",
                expertName = queryParams?.get("expert") ?: "",
                expertImage = queryParams?.get("image") ?: "",
                expertSkills = queryParams?.get("skills") ?: "",
                callType = queryParams?.get("callType") ?: ""
            )
            route == Paths.TRANSACTION_HISTORY -> Configuration.TransactionHistoryComponent
            route == Paths.CHAT_HISTORY -> Configuration.ChoseRechargePage
            route == "home" -> Configuration.LoginPage
            route == Paths.CUSTOM_ORDER -> Configuration.CustomOrderPage
            pathSegments.firstOrNull() == Paths.CUSTOM_ORDER_LESSON -> {
                val customOrderId = pathSegments.getOrNull(1)
                if (customOrderId.isNullOrBlank()) Configuration.BottomNavigationConfiguration
                else Configuration.CustomOrderPage
            }
            route == Paths.PURCHASE_HISTORY -> Configuration.PurchaseHistoryConfig
            route == Paths.REFER_AND_EARN -> Configuration.ReferAndEarnConfig
            route == Paths.POST -> Configuration.PostScreenConfig
            pathSegments.firstOrNull() == Paths.POST_DETAILS -> {
                val post = pathSegments.getOrNull(1)
                if (post.isNullOrBlank()) Configuration.PostScreenConfig
                else Configuration.PostDetailsConfig(post)
            }
            route == Paths.ABOUT_US -> Configuration.AboutUsConfig
            route == Paths.CONTACT_US -> Configuration.ContactUsConfig
            else -> Configuration.BottomNavigationConfiguration
        }
    }
}

sealed class DeepLink {
    data object None : DeepLink()
    data class Web(val path: String) : DeepLink()
}
